import CylinderCurrentInfo from "./CylinderCurrentInfo";
import CylinderHistoryList from "./history-view/CylinderHistoryList";
import NoHistoryView from "../NoHistoryView";
import { useState } from "react";
import CylinderHistoryTabs from "./CylinderHistoryTabs";
import StateHistoryView from "./StateHistoryView";

const CylinderHistoryContainer = ({ isSucceed }) => {
  const [currentTab, setCurrentTab] = useState("transport");
  return (
    <div className="cy-history-container">
      {isSucceed ? (
        <>
          <CylinderHistoryTabs
            currentTab={currentTab}
            setCurrentTab={setCurrentTab}
          />
          <CylinderCurrentInfo />
          {currentTab === "transport" ? (
            <CylinderHistoryList />
          ) : (
            <StateHistoryView />
          )}
        </>
      ) : (
        <NoHistoryView msg="No Cylinder History Searched..!" />
      )}
    </div>
  );
};

export default CylinderHistoryContainer;
